var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.tooltip,
    placement: 'bottom',
  }),expression:"{\n    content: tooltip,\n    placement: 'bottom',\n  }"}],class:['log-time-button', _vm.buttonClasses]},[_c('CommonIcons',{staticClass:"icon",attrs:{"id":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }